import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "tw-fixed tw-top-0 tw-left-0 tw-bottom-0 tw-right-0 tw-z-30 tw-text-center" }
const _hoisted_2 = {
  ref: "taskWrap",
  class: "tw-absolute tw-top-0 md:tw-top-[30px] tw-left-[30px] tw-bottom-[30px] tw-right-[30px] tw-text-2xl"
}
const _hoisted_3 = { class: "tw-absolute tw-top-0 tw-left-0 tw-bottom-0 tw-right-0 tw-flex tw-justify-center tw-items-center" }
const _hoisted_4 = { class: "tw-absolute tw-top-[16px] tw-right-[16px] tw-z-10" }
const _hoisted_5 = { class: "tw-relative tw-top-0 tw-left-0 tw-w-[640px] tw-h-[480px] tw-bg-mainbg1 tw-border-2 tw-border-solid tw-border-primary tw-rounded-3xl tw-p-[10px] tw-text-primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CloseX = _resolveComponent("CloseX")!
  const _component_SpellingGameEnd = _resolveComponent("SpellingGameEnd")!
  const _component_ActivityIntro = _resolveComponent("ActivityIntro")!
  const _component_ActivityGame = _resolveComponent("ActivityGame")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
      class: "tw-absolute tw-top-0 tw-left-0 tw-bottom-0 tw-right-0 tw-bg-mainbg1 tw-opacity-70"
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "tw-relative tw-w-[640px] tw-h-[480px]",
          style: _normalizeStyle(_ctx.wrapStyle)
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_CloseX, {
              size: "25px",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('close')))
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.saveStatus != 0)
              ? (_openBlock(), _createBlock(_component_SpellingGameEnd, {
                  key: 0,
                  onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
                }))
              : (_ctx.screen == 'intro')
                ? (_openBlock(), _createBlock(_component_ActivityIntro, {
                    key: 1,
                    "user-full-name": _ctx.$currentUser.value?.fullName
                  }, null, 8, ["user-full-name"]))
                : (_ctx.screen == 'game')
                  ? (_openBlock(), _createBlock(_component_ActivityGame, { key: 2 }))
                  : _createCommentVNode("", true)
          ])
        ], 4)
      ])
    ], 512)
  ]))
}